import React, { ReactElement } from "react";
import { Checkbox } from "@components/form";
import { useState } from "@helpers/Store";
import * as Type from "@interface/index";

interface IProps {
  setNetworkingProfile: any;
  companySpecializationsList: number[];
  networkingProfile: {
    interestCompanyTypes: number[];
    languages: number[];
    directions: number[];
    specializations: number[];
    about: string;
  };
  editMode: boolean;
}

const Specialization = ({
  companySpecializationsList,
  networkingProfile,
  setNetworkingProfile,
  editMode,
}: IProps): ReactElement => {
  // const [selectedLanguages, setSelectedLanguages] = useState(networkingProfile.languages)

  const onCheckHandler = (
    event: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >
  ): void => {
    if (networkingProfile?.specializations?.includes(+event.target.value)) {
      networkingProfile?.specializations?.splice(
        networkingProfile?.specializations?.indexOf(+event.target.value),
        1
      );
    } else {
      networkingProfile?.specializations?.push(+event.target.value);
    }
    setNetworkingProfile({ ...networkingProfile });
  };

  if (editMode) {
    return (
      <div className="profile-netw-step">
        <div className="profile-netw-step__body">
          <div className="profile-netw-step__body-header">
            <p className="profile-netw-step__title">
              <span>Для сотрудников ТА и ТО:</span> На каких видах туризма вы
              специализируетесь?
            </p>
          </div>
          <p className="profile-netw-step__desc profile-netw-step__desc--small">
            Отметьте один или несколько пунктов, если данные виды туризма
            занимают существенную долю в ваших продажах.{" "}
          </p>
          <div className="profile-netw-step__main profile-netw-step__main--checkbox-list">
            {companySpecializationsList?.map((Item: any) => {
              return (
                <Checkbox
                  key={Item.id}
                  name="languages"
                  type="profile"
                  placeholder={Item.name}
                  value={Item.id}
                  hiddenInput
                  checked={networkingProfile?.specializations?.includes(
                    Item.id
                  )}
                  onChange={onCheckHandler}
                />
              );
            })}
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className="profile-netw-step">
        <div className="profile-netw-step__body">
          <div className="profile-netw-step__body-header">
            <p className="profile-netw-step__title">
              <span>Для сотрудников ТА и ТО:</span> На каких видах туризма вы
              специализируетесь?
            </p>
          </div>
          <div className="profile-netw-step__main profile-netw-step__main--item-list">
            {companySpecializationsList?.map((Item: any) => {
              return networkingProfile?.specializations?.includes(Item.id) ? (
                <div key={Item.id} className="profile-netw-step__main-item">
                  {Item.name}
                </div>
              ) : (
                <></>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
};

export default Specialization;
